import DOMPurify from 'isomorphic-dompurify';
import { marked } from 'marked';

const trimMarkdownText: (text: string) => string = (text: string): string => {
  const result: RegExpMatchArray | null = text.match(/^(\*\*[\ ]*)(([^\ ]+)(.*)([^\ ]+))([\ ]*\*\*)$/);

  if (result) {
    return `**${result[2]}**`;
  }

  return text;
};

export const toMarkdown: (text: string) => string = (text: string): string => {
  return DOMPurify.sanitize(
    marked(trimMarkdownText(text), { breaks: true }),
    { ADD_ATTR: ['target'] },
  );
};

/**
 * Markdown bez opakowania w akapit — do treści, która ma stać WEWNĄTRZ nagłówka.
 *
 * `toMarkdown` zawija wynik w `<p>`, a `<p>` w środku `<h1>` to niepoprawny HTML:
 * przeglądarka rozbija wtedy nagłówek i zostaje on pusty. Wersja liniowa zachowuje
 * pogrubienia, łamania wiersza i akcenty kolorystyczne, a nie dokłada akapitu.
 */
export const toMarkdownInline: (text: string) => string = (text: string): string => {
  return DOMPurify.sanitize(
    marked.parseInline(trimMarkdownText(text), { breaks: true }),
    { ADD_ATTR: ['target'] },
  );
};
